import { Dispatch, SetStateAction, useState } from 'react';
import { PendingRespondent } from 'src/@types/pendingRespondentStatus';
import { usePendingRespondentApi } from 'src/api/usePendingRespondentApi';

type UseIdIssuanceManagementDetailProps = {
  selectedUser: PendingRespondent;
  setSelectedUser: Dispatch<SetStateAction<PendingRespondent | undefined>>;
};

export const useIdIssuanceManagementDetail = ({ selectedUser, setSelectedUser }: UseIdIssuanceManagementDetailProps) => {
  const [isOpenDeleteConfirm, setIsOpenDeleteConfirm] = useState<boolean>(false);
  const { deletePendingRespondent } = usePendingRespondentApi();

  const onDelete = async () => {
    const result = await deletePendingRespondent(selectedUser.respondentRequestId, [selectedUser.email]);
    if (result) {
      // NOTE: 正常に削除できた場合は一覧を表示する
      setSelectedUser(undefined);
    }
  };

  return { onDelete, isOpenDeleteConfirm, setIsOpenDeleteConfirm };
};
